import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faTimesCircle } from '@fortawesome/pro-solid-svg-icons';

export default class SearchPageCurrentFilters extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    newDesignSystem: PropTypes.bool,
    raw: PropTypes.bool,
    onClearFilters: PropTypes.func
  }

  static defaultProps = {
    newDesignSystem: false
  };

  render() {
    const { newDesignSystem, raw } = this.props;

    if (raw || newDesignSystem) {
      return <div>{this.renderTags()}</div>;
    }

    return (
      <div className="row">
        <div className="top-buffer-xs mx-5">
          {this.renderTags()}
        </div>
      </div>
    );
  }

  renderTags() {
    const { children, newDesignSystem, onClearFilters } = this.props;

    if (React.Children.count(children) === 0) return null;

    const oldFilterClassName = 'clear-filter-tag clickable left-buffer-md';
    const newFilterClassName = 'px-2 d-inline-block ds-button ds-button--accent ds-button--outlined' +
      ' ds-button--plain ml-2';
    const clearFilterClassName = newDesignSystem ? newFilterClassName : oldFilterClassName;
    const icon = newDesignSystem ? faTimesCircle : faTimes;

    return (
      <React.Fragment>
        {!newDesignSystem && (<span className="text-muted">CURRENT FILTERS: </span>)}
        {newDesignSystem && (<span className="fw-bold">ACTIVE FILTERS: </span>)}
        {children}
        <button
          className={clearFilterClassName}
          key="clear-all"
          name="clear_filters"
          style={{ minHeight: '32px' }}
          onClick={onClearFilters}
        >
          <FontAwesomeIcon className="right-buffer-sm" icon={icon} size="sm"/>
          Clear All
        </button>
      </React.Fragment>
    );
  }
}
